import { add } from "vega-lite/build/src/compositemark";
import { deleteImageResponse, locationTypes } from "../actions/location";

const initialState = {
  isLoading: false,
  isApiLoading: false,
  currentModal: false,
  isLoadingAlarmCount: false,
  isCreating: false,
  isDownloaded: "",
  shouldUpdate: false,
  ui: {
    notification: {
      isActive: false,
      type: "success",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
    form: {
      type: "",
      single: {
        id: null,
        name: "",
      },
      fields: {
        errors: {},
        pointName: "",
        address: "",
        latitude: "",
        longitude: "",
        radius: 500,
        isAdjustGeofanceOnMap: false,
      },
    },
  },
  data: {
    locations: [],
    locationsAll : [],
    total: 0,
  },
  filter: {
    name: "",
    address: "",
    createtype: "",
    limit: 10,
    pageNo: 0,
  },
   locationtype: {
      sort: "",
      option: [
        {
          text: "Shipment",
          value: false
        },
        {
          text: "Inventory",
           value: false
        },
      ],
    },
  alarmCounts: {},
  current_modal : '',
  next_modal : '',
  location_data: {
    newZones:{},
    addNewZoneButtonClicked:false,
    zone_coordinates_temp: [],
    action_type : 'add',
    name:'',
    address: "",
    adjustgeofencemap: false,
    lat_value: '',
    long_value: '',
    radius: 500,
    addfloormap : false,
    addgateway : false,
    createtype : '',
    floors : {},
    zoneCoordinates: [],
    uploadImageResponse: {
      data: null,
      success: null,
    },
    isUploadingImage: false,
    isDeleteImage: false,
    imageIdsForDelete: [],
    deleteImageResponse: {
      data: null,
      success: null,
    },
    fetchImageResponse: {
      data: null,
      success: null,
    },
    isFetchingImage: false,
  },
  addNewZoneButtonClicked: false,
  editZoneSelected: false,
  zoneErrors: { initial: true },
  error: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case locationTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        filter: {
          ...state.filter,
          name: action.payload ? "" : state.filter.name,
          address: action.payload ? "" : state.filter.address,
          createtype: action.payload ? "" : state.filter.createtype,
          pageNo: action.payload ? 0 : state.filter.pageNo,
          limit: action.payload ?  action.payload : state.filter.limit > 100 ? 10 : state.filter.limit,
        },
      };
    case locationTypes.FETCH_REQUEST_ALL:
      return {
        ...state,
        isLoading: true,
        filter: { },
      };
    case locationTypes.UPDATE_IS_LOADING_API:
      return {
        ...state,
        isApiLoading: action.payload,
      };
    case locationTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: true,
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case locationTypes.FETCH_SUCCESS_ALL:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          locationsAll: action.payload.locations,
        },
      };
    case locationTypes.FETCH_FAILURE_ALL:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          locationsAll: [],
        },
        error: action.payload,
      };
    case locationTypes.ALARM_COUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: false,
        alarmCounts: action.payload,
      };
    case locationTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoadingAlarmCount: false,
        alarmCounts: {},
        error: action.payload,
      };
    case locationTypes.RESET_LOCATION_DATA:
      return {
        ...state,
        location_data:{
          ...initialState.location_data
        },
        current_modal: '',
        next_modal: 'AddFloor',
        ...action.payload
      }
    case locationTypes.RESET_LOCATION_DATA_ONLY:
      return {
        ...state,
        location_data:{
          ...initialState.location_data,
          ...action.payload
        },
        next_modal: action.payload?.next_modal
      }
    case locationTypes.UPDATE_MODAL:
      return {
        ...state,
        ...action.payload,
      }
    case locationTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case locationTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case locationTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    case locationTypes.SET_CURRENT_MODAL:
      return {
        ...state,
        currentModal: action.payload,
      };
    case locationTypes.SET_LOCATION_DATA:
      return {
        ...state,
        location_data: {
          ...state.location_data,
          ...action.payload,
        },
      };
    case locationTypes.UPDATE_UI:
      return {
        ...state,
        ui: {
          ...state.ui,
          [action.payload.key]: {
            ...state.ui[action.payload.key],
            ...action.payload.state,
          },
        },
      };
    case locationTypes.CREATE_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case locationTypes.CREATE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        ui: {
          ...state.ui,
          notification: {
            type: "success",
            isActive: true,
            message: "Create Location",
            description: action.payload,
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          form: {
            type: "",
            single: {
              id: null,
              name: "",
            },
            fields: {
              errors: {},
              pointName: "",
              address: "",
              latitude: "",
              longitude: "",
              radius: 500,
              isAdjustGeofanceOnMap: false,
            },
          },
        },
        error: null,
      };
    case locationTypes.CREATE_FAILURE:
      return {
        ...state,
        isCreating: false,
        ui: {
          ...state.ui,
          notification: {
            type: "error",
            isActive: true,
            message: "Create profile error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
          form: {
            type: "",
            single: {
              id: null,
              name: "",
            },
            fields: {
              errors: {},
              pointName: "",
              address: "",
              latitude: "",
              longitude: "",
              radius: 500,
              isAdjustGeofanceOnMap: false,
              isFullScreen: false,
            },
          },
        },
        error: action.payload,
      };
    case locationTypes.UPDATE_PAGINATION_REQUEST:
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        filter: {
          ...state.filter,
          ...action.payload,
        },
      };
    case locationTypes.UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          uploadImageResponse: {
            data: null,
            success: null,
          },
          isUploadingImage: true,
        }
      };
    case locationTypes.DELETE_IMAGE_REQUEST:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          deleteImageResponse: {
            data: null,
            success: null,
          },
          isDeleteImage: true,
        }
      };
    case locationTypes.FETCH_IMAGE_REQUEST:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          fetchImageResponse: {
            data: null,
            success: null,
          },
          isFetchingImage: true,
        }
      };
    case locationTypes.FETCH_IMAGE_RESPONSE:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          fetchImageResponse: {
            ...state.location_data.fetchImageResponse,
            ...action.payload,
          },
          isFetchingImage: false,
        }
      };
    case locationTypes.DELETE_IMAGE_RESPONSE:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          deleteImageResponse: {
            data: action.payload.data,
            success: action.payload.success,
          },
          isDeleteImage: false,
        }
      };
    case locationTypes.UPLOAD_IMAGE_RESPONSE:
      return {
        ...state,
        location_data:{
          ...state.location_data,
          uploadImageResponse: {
            data: action.payload.data,
            success: action.payload.success,
          },
          isUploadingImage: false,
        }
      };
    case locationTypes.LOCATION_RESET_FILTERS:
  return {
    ...state,
    filter: {
      ...initialState.filter,
      ...action.payload,
      name: "",    
      address: "", 
    },
    locationtype: {
      ...state.locationtype,
      option: initialState.locationtype.option.map(opt => ({
        ...opt,
        value: false
      }))
    }
  };
    default:
      return state;
  }
};

export default locationReducer;
